// Sends that clear their draft only after the network round-trip leave the composer interactive
// while the request is out, so a second click would post again. Callers claim the composition
// before sending and release it when the request settles.
const inFlight = new Set();

export function beginSend(compositionId) {
  if (inFlight.has(compositionId)) return false;
  inFlight.add(compositionId);
  return true;
}

export function endSend(compositionId) {
  inFlight.delete(compositionId);
}
